'use strict';
const config = require('@mindmup/config'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	authenticationDriveStart = require('../features/authentication/authentication-drive-start'),
	GoldAWSApi = require('../models/gold-aws-api'),
	OAuthApi = require('../models/oauth-api'),
	MicrosoftAuthShim = require('../models/microsoft-auth-shim'),
	MicrosoftAuthenticator = require('../models/microsoft-authenticator'),
	pageActionsStart = require('../features/page-actions-start'),
	S3Api = require('../models/s3-api'),
	AjaxPromise = require('../models/ajax-promise'),
	plans = require('../models/plans'),
	TaskBuilder = require('../models/task-builder'),
	CountryListModel = require('../models/country-list-model'),
	TokenParser = require('../models/token-parser'),
	mmWidgets = require('../widgets/mm-widgets'),
	{ initGAConsent } = require('./ga-consent');

require('../widgets/account-info-value-toggle-widget');
require('../widgets/account-info-value-widget');
require('../widgets/user-profile-widget');
require('../widgets/subscription-purchase-widget');
require('../widgets/domain-signup-widget');
require('../widgets/terms-and-conditions-widget');
require('../widgets/gold-plan-selector-widget');
require('../widgets/gold-currency-selector-widget');
require('../widgets/contact-link-widget');
require('../widgets/visibility-observer');
require('../widgets/country-list-widget');

module.exports = function () {
	const navigatorShim = new NavigatorShim(),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationDriveStart(config, navigatorShim, ajaxPromise, goldApi, {scope: config.driveScope.basic}),
		microsoftAuthShim = new MicrosoftAuthShim({
			client_id: config.microsoftAppId,
			scope: 'User.Read openid profile'
		}, navigatorShim, ajaxPromise),
		microsoftOAuthApi = new OAuthApi(microsoftAuthShim),
		tokenParser = new TokenParser(),
		microsoftAuthenticator = new MicrosoftAuthenticator({microsoftOAuthApi, authenticationModel: authentication.authenticationModel, goldApi, tokenParser}, {skipConfirmation: true, allowUnlicensed: true}),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		taskBuilder = new TaskBuilder(goldApi, s3Api, navigatorShim, authentication.authenticationModel.getLicense),
		countryListModel = new CountryListModel({goldApi}),
		components = Object.assign({
			microsoftOAuthApi, microsoftAuthenticator, taskBuilder,
			navigatorModel: navigatorShim,
			countryListModel
		}, authentication);
	
	initGAConsent(config);
	pageActionsStart(components);

	window.components = components;
	mmWidgets('[data-mm-account-info-toggle]').accountInfoValueToggleWidget(authentication.subscriptionModel, authentication.authenticationModel);
	mmWidgets('[data-mm-subscription-value]').accountInfoValueWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-user-profile]').userProfileWidget(authentication.authenticationModel);

	mmWidgets('[data-mm-role~="subscriptionPurchase"]').subscriptionPurchaseWidget({subscriptionModel: authentication.subscriptionModel, subscriptionPlanModel, navigatorShim, listenForExpiredSubscription: true, taskBuilder, countryListModel});

	mmWidgets('[data-mm-role~="domainAccountSignup"]')
		.domainSignupWidget(authentication.subscriptionModel, authentication.authenticationModel, subscriptionPlanModel);

	mmWidgets('[data-mm-role~="domainAccountSignup"]')
		.termsAndConditionsWidget(authentication.subscriptionModel)
		.visibilityObserver();
	mmWidgets('[data-mm-role~="plan-selector"]').goldPlanSelectorWidget(subscriptionPlanModel);
	mmWidgets('[data-mm-role~="currency-selector"]').goldCurrencySelectorWidget(subscriptionPlanModel);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);
	mmWidgets('[data-mm-role~="country-list"]').countryListWidget({countryListModel});
};
